export const logoStyleObject = {
  width: 110,
  height: 70,
  zIndex: 100,
  margin: '1rem',
  cursor: 'pointer',
};

export const logoStyleMobileView = {
  width: 70,
  height: 50,
  zIndex: 100,
  margin: '1rem',
};
